import {createContext, useContext} from "react"

const SideBarMenuOpenedContext = createContext(null)
const useSideBarMenuOpened = () => useContext(SideBarMenuOpenedContext)

export {SideBarMenuOpenedContext}
export default useSideBarMenuOpened
